import styled, { useTheme } from 'styled-components';

import DashIcon from '../Icons/components/affiliate/DashIcon';

type Props = {
  label: string;
  state: 'active' | 'inactive';
  onClick?: () => void;
};

const TabButton = ({ label, state = 'inactive', onClick }: Props) => {
  const theme = useTheme();
  const iconColor = state === 'inactive' ? theme.color.static.black : theme.color.static.white;

  return (
    <SWrapper state={state} onClick={onClick}>
      <DashIcon size={20} color={iconColor} />
      {label}
    </SWrapper>
  );
};

export default TabButton;

const SWrapper = styled.button<{ state: 'active' | 'inactive' }>`
  height: 48px;
  padding: 14px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 26px;
  background: ${({ theme, state }) => (state === 'inactive' ? theme.color.buttons.default : theme.color.static.black)};
  color: ${({ theme, state }) => (state === 'inactive' ? theme.color.text.default : theme.color.static.white)};
  ${({ theme }) => theme.font.body3_m};
`;
